import React, { useState, useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import {
  getViajes,
  anularViaje,
  getViajeById,
} from "../helpers/rutaViajes";
import ModalFormViaje from "./ModalFormViaje";
import "../css/tablecomandas.css";
import { generarPDFviajeConDetalles } from "../helpers/pdfViajes"; // Asegurate de crear este archivo y función


const TableViajes = () => {
  const [viajes, setViajes] = useState({
    data: { viajes: [] },
    loading: true,
  });

  const [viaje, setViaje] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaViajes();
  }, []);

  const consultaViajes = () => {
    getViajes().then((datos) => {
      if (Array.isArray(datos)) {
        setViajes({
          data: { viajes: datos },
          loading: false,
        });
      } else {
        console.error("Error al obtener viajes:", datos);
      }
    });
  };

  const anularViajeHandler = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea anular el viaje?");
    if (confirmar) {
      anularViaje(id).then(() => {
        consultaViajes();
      });
    }
  };

  const modificaViaje = async (id) => {
    const resp = await getViajeById(id);
    if (resp.ok) {
      setViaje(resp.viaje);
      setShow(true);
    } else {
      console.error("❌ Error al obtener viaje:", resp.error || "Respuesta vacía");
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaViajes();
  };

  const calcularResumen = (v) => {
    const kmTableros = (v.combustible || [])
      .map(c => Number(c.kmTablero))
      .filter(km => !isNaN(km));

    const totalKm = kmTableros.length >= 2
      ? Math.max(...kmTableros) - Math.min(...kmTableros)
      : 0;

    const tarifa = Number(v.tarifaPorKm || 130);
    const totalLitros = (v.combustible || []).reduce((sum, c) => sum + Number(c.litros), 0);
    const totalCombustible = (v.combustible || []).reduce((sum, c) => sum + Number(c.monto), 0);
    const totalViaticos = (v.viaticos || []).reduce((sum, v) => sum + Number(v.monto), 0);
    const totalAdelantos = (v.adelantos || []).reduce((sum, a) => sum + Number(a.monto), 0);
    const totalGastos = (v.gastos || []).reduce((sum, g) => sum + Number(g.monto), 0);

    const promedioConsumo = totalLitros > 0 ? (totalKm / totalLitros).toFixed(2) : "-";
    const liquidacionFinal1 = (totalKm * tarifa) + totalViaticos;
    const liquidacionFinal2 = totalAdelantos - totalGastos;
    const liquidacionFinal = liquidacionFinal1 - liquidacionFinal2;

  return {
    totalKm,
    totalLitros,
    promedioConsumo,
    totalCombustible,
    totalViaticos,
    totalAdelantos,
    totalGastos,
    liquidacionFinal,
    valorKm: tarifa,
    valorViaje: totalKm * tarifa
  };

  };

  return (
    <div className="table-container">
      <h5 className="mt-3">Listado de Viajes</h5>
      <Button variant="dark" onClick={consultaViajes}>Actualizar</Button>

      {!viajes.loading && (
        <>
          <Table striped bordered hover className="table-container mt-3">
            <thead>
              <tr>
                <th className="acciones" style={{ width: 80, minWidth: 80, maxWidth: 80, whiteSpace: 'nowrap' }}>  Acciones</th>
                <th>Nro Viaje</th>
                <th>Chofer</th>
                <th className="" style={{ width: 120, minWidth: 120, maxWidth: 120, whiteSpace: 'nowrap' }}>Camión</th>
                <th>Total KM</th>
                <th>Valor KM</th>
                <th>Valor Viaje</th>
                <th>Combustible</th>
                <th>Promedio</th>
                <th>Viáticos</th>
                <th>Adelantos</th>
                <th>Gastos</th>
                <th>Total a Cobrar</th>
              </tr>
            </thead>

            <tbody>
              {viajes.data.viajes.map((v) => {
                const resumen = calcularResumen(v);
                return (
<tr key={v._id}>
  <td>
    <button className="btn btn-primary btn-sm mr-2" onClick={() => modificaViaje(v._id)}>
      <i className="fa fa-pencil" />
    </button>
    <button className="btn btn-danger btn-sm" onClick={() => anularViajeHandler(v._id)}>
      <i className="fa fa-trash" />
    </button>
    <button
      className="btn btn-secondary btn-sm ml-2"
      onClick={() => generarPDFviajeConDetalles(v)}
      title="Generar PDF completo"
    >
      <i className="fa fa-file-pdf-o" />
    </button>
  </td>
  <td>{v.nroViaje}</td>
  <td>{v.choferId?.nombre || "-"}</td>
  <td>{v.camionId ? `${v.camionId.camion || ''} (${v.camionId.patente || ''})` : '-'}</td>
  <td>{resumen.totalKm}</td>
  <td>{resumen.valorKm.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
  <td>{resumen.valorViaje.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
  <td>{resumen.totalCombustible.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
  <td>{resumen.promedioConsumo}</td>
  <td>{resumen.totalViaticos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
  <td>{resumen.totalAdelantos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
  <td>{resumen.totalGastos.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
  <td>{resumen.liquidacionFinal.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
</tr>

                );
              })}
            </tbody>
          </Table>

          <ModalFormViaje
            show={show}
            handleClose={handleClose}
            viaje={viaje}
          />
        </>
      )}
    </div>
  );
};

export default TableViajes;
